import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import Dropdown from '../Dropdown'
import { Spacer } from '@cleartrip/bento'
import Calendar from '../Calendar'
import Overlay from '../../lib/Overlay'
import { isEmpty, appPrefix, getCookie } from 'utils/browserHelper'
import OutsideClickHandler from 'lib/OutsideClickHandler'
import { getFormattedDate, getInitialMonthRange } from 'utils/dateHelper'
import { getDateTabFares } from 'api/flights/results'
import langTranslate from 'locale'
import Clevertap from 'analytics'

import { DOMAIN } from 'constants/base'
import { DOMAIN_COUNTRY_MAP } from 'constants/flightResults'
import './_homecalendar.scss'
import DropdownSelect from './dropdownSelect'
const CalendarWrapper = props => {
    const isRtl = process.env.CONTENT_DIR === 'RTL'
    const {
        roundTrip,
        departDate,
        returnDate,
        dateClick,
        searchParams,
        isMulticity = false,
        fromDate,
        index = 1,
        multiCityDestinations = {},
        onwardJourny = '',
        returnJourny = '',
        fromCode = '',
        toCode = '',
        getAbTest = {},
        journeyType,
        setTripSelect
    } = props
    const dateformatOptions = { weekday: 'short', month: 'short', day: 'numeric' }
    const [activeOnward, setActiveOnward] = useState(false)
    const [activeReturn, setActiveReturn] = useState(false)
    const [openCalendar, setOpenCalendar] = useState(false)
    const [isRoundTrip, setIsRoundTrip] = useState(roundTrip)
    const [fareCalendar, setfareCalendar] = useState({})
    let formDate = departDate ? new Date(getFormattedDate(departDate, 'MM/DD/YYYY', 'DD/MM/YYYY')) : new Date()

    if (isMulticity && isEmpty(departDate)) {
        formDate = ''
    } else if (isMulticity) {
        formDate = new Date(getFormattedDate(multiCityDestinations[`depart_date_${index}`], 'MM/DD/YYYY', 'DD/MM/YYYY'))
    }
    let toDate = returnDate ? new Date(getFormattedDate(returnDate, 'MM/DD/YYYY', 'DD/MM/YYYY')) : formDate
    const [range, setRange] = useState({ from: formDate, to: toDate, enteredTo: toDate })

    useEffect(() => {
        setRange({
            ...range,
            from: formDate
        })
    }, [departDate])

    useEffect(() => {
        setIsRoundTrip(roundTrip)
        if (!roundTrip) {
            setRange({
                ...range,
                to: null,
                enteredTo: null,
                from: formDate
            })
        } else {
            if (searchParams.return_date)
                setRange({
                    ...range,
                    to: toDate,
                    enteredTo: toDate,
                    from: formDate
                })
        }
    }, [activeReturn, roundTrip])
    useEffect(() => {
        if (
            isMulticity &&
            !isEmpty(multiCityDestinations[`depart_date_${index}`]) &&
            range.from !== multiCityDestinations[`depart_date_${index}`]
        ) {
            setRange({
                ...range,
                from: new Date(
                    getFormattedDate(multiCityDestinations[`depart_date_${index}`], 'MM/DD/YYYY', 'DD/MM/YYYY')
                )
            })
        }
    }, [multiCityDestinations])

    function handleOnwardClick() {
        getDateRangePrice(getInitialMonthRange(isMulticity ? fromDate : departDate))
        setActiveOnward(!activeOnward)
        setActiveReturn(false)
        if (openCalendar && !activeReturn) {
            setOpenCalendar(!openCalendar)
        } else {
            setOpenCalendar(true)
        }
    }
    function handleReturnClick() {
        setActiveOnward(false)
        setActiveReturn(!activeReturn)
        setfareCalendar({})
        if (openCalendar && !activeOnward) {
            setOpenCalendar(!openCalendar)
        } else {
            getDateRangePrice(getInitialMonthRange(isMulticity ? fromDate : departDate), true)
            Clevertap.event('Air_UI_Action', {
                action_type: 'BUTTON',
                action_name: 'hp_return_on_clicked'
            })
            setOpenCalendar(true)
        }
    }
    function directionClick(departRange) {
        getDateRangePrice(departRange)
    }
    function formatDate(date) {
        let localeOption = 'en-US'
        if (getCookie('lp') === 'ar' && appPrefix === '/ar') {
            localeOption = 'ar'
        }
        if (date) {
            return date.toLocaleDateString(localeOption, dateformatOptions)
        }
    }
    function setDates(dates) {
        setRange({ ...range, ...dates })
        dateClick(dates, range)
        if (isRoundTrip && dates['to']) {
            setOpenCalendar(false)
            setActiveOnward(false)
            setActiveReturn(false)
        }
        if (isRoundTrip && dates['from'] && journeyType == 'R') {
            setActiveOnward(false)

            handleReturnClick()
        } else {
            setOpenCalendar(false)
            setActiveOnward(false)
            setActiveReturn(false)
        }
    }

    function outsideCalendar() {
        setOpenCalendar(false)
        setActiveReturn(false)
        setActiveOnward(false)
    }
    const getDateRangePrice = async (departRange, roundtrip = false) => {
        const requestParams = {
            searchParams: !roundtrip
                ? {
                      ...searchParams,
                      from: !isEmpty(fromCode) ? fromCode : searchParams.from,
                      to: !isEmpty(toCode) ? toCode : searchParams.to,
                      destination: !isEmpty(returnJourny) ? returnJourny : searchParams.destination,
                      origin: !isEmpty(onwardJourny) ? onwardJourny : searchParams.origin,
                      destinationCountry: '',
                      sourceCountry: '',
                      sellingCountry: DOMAIN_COUNTRY_MAP[DOMAIN] || ''
                  }
                : {
                      ...searchParams,
                      from: !isEmpty(toCode) ? toCode : searchParams.to,
                      to: !isEmpty(fromCode) ? fromCode : searchParams.from,
                      destination: !isEmpty(onwardJourny) ? onwardJourny : searchParams.origin,
                      origin: !isEmpty(returnJourny) ? returnJourny : searchParams.destination,

                      destinationCountry: '',
                      sourceCountry: '',

                      sellingCountry: DOMAIN_COUNTRY_MAP[DOMAIN] || ''
                  },

            journey: !roundtrip ? 'onward' : 'return',
            depart_date_range: !roundtrip ? departRange : '',
            return_date_range: !roundtrip ? '' : departRange,
            filters: { onward: {} }
        }

        if (!isMulticity) {
            const response = await getDateTabFares(requestParams)
            let { data: flexiSearchData = {} } = response || {}

            if (roundtrip) {
                flexiSearchData = { ...flexiSearchData, onward: flexiSearchData.return }
            }
            if (!isEmpty(flexiSearchData)) {
                setfareCalendar(reformFareCalResponse(flexiSearchData))
            }
        }
    }
    function reformFareCalResponse(response) {
        const onward = {}
        const cheapFare = {}
        if (response.onward) {
            response.onward.forEach(elem => {
                onward[elem.date] = elem

                const fullMonth = getFormattedDate(elem.date, 'DD-MMMM-YYYY', 'DD/MM/YYYY')
                const month = fullMonth.split('-')[1]
                const curPrice = elem.pr || '-'
                if (cheapFare[month]) {
                    if (parseInt(cheapFare[month], 10) > parseInt(curPrice, 10) && curPrice !== '-') {
                        cheapFare[month] = curPrice
                    }
                } else if (curPrice !== '-') {
                    cheapFare[month] = curPrice
                }
            })
        }
        return { ...response, onward, cheapFare }
    }

    return (
        <OutsideClickHandler onOutsideClick={() => outsideCalendar()}>
            <div className="flex flex-middle p-relative homeCalender">
                <DropdownSelect
                    className="c-neutral-900"
                    width={191}
                    height={52}
                    hasError={isMulticity && multiCityDestinations[`depart_date_${index}Error`]}
                    active={activeOnward}
                    label={formatDate(range['from'])}
                    onClick={handleOnwardClick}
                    placeHolder={isMulticity ? langTranslate('Pick a date') : langTranslate('Onward')}
                />

                <DropdownSelect
                    className="c-neutral-900"
                    width={185}
                    height={52}
                    active={activeReturn}
                    label={journeyType === 'O' ? '' : formatDate(range['to'])}
                    disable={true}
                    placeHolder={langTranslate('Return')}
                    onClick={handleReturnClick}
                />

                <Dropdown.Menu
                    active={openCalendar}
                    distance={isMulticity ? -258 : 0}
                    className="t-48 br-12"
                    width={764}
                >
                    <Spacer className="pt-3" />
                    <div
                        className="p-absolute"
                        style={{ left: '50%', height: 365, top: 25, borderLeft: '1px dotted rgb(187, 187, 187)' }}
                    ></div>
                    <Calendar
                        isRtl={isRtl}
                        className="w-100p"
                        title="New Delhi → Bangalore"
                        selectedDates={range}
                        roundTrip={isRoundTrip}
                        onClickCalendar={setDates}
                        fareCalendar={fareCalendar}
                        directionClick={directionClick}
                        activeOnward={activeOnward}
                        activeReturn={activeReturn}
                        isMulticity={isMulticity}
                        multiCityDestinations={multiCityDestinations}
                        index={index}
                    />
                </Dropdown.Menu>
            </div>
        </OutsideClickHandler>
    )
}

export default CalendarWrapper
